import React from 'react';
import { Button, Tooltip } from 'antd';
import cn from 'classnames';
import styles from './ActionBtn.module.scss';

const ActionBtn = ({ className, tooltipProps, disabled = false, ...props }) => {
  const button = (
    <Button
      {...props}
      className={cn(className, styles.root, { [styles.disabled]: disabled })}
    />
  );

  return tooltipProps ? <Tooltip {...tooltipProps}>{button}</Tooltip> : button;
};

export default ActionBtn;
